import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App,PopoverController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../view-contact/view-contact';
import { HomePage } from '../home/home';
import { SdfFormService } from '../../app/services/sdf-form-service';
//import { post, event } from 'jquery';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../app/services/env-data-service';
import { ContactFormService } from '../edit-contact-form-list/services/contact-form.service';
import { EditContactList } from '../edit-contact-form-list/edit-contact-from-list';
import { ShowContactPdfPage } from '../show-contact-pdf/show-contact-pdf';
import { AllowCustomerContactPermissionPage } from '../allow-customer-contact-permission/allow-customer-contact-permission';
import {AdfPage} from '../adf-page/adf-page';
import { ViewAdfPage } from '../view-adf/view-adf';
import { ADFFormService } from '../adf-page/services/adf-form.service';
import { ViewMoreAddressPage } from '../view-more-address/view-more-address';
import {ViewDealPage} from '../view-deal/view-deals';
import {BrokerpagepopComponent} from '../../components/brokerpagepop/brokerpagepop';
declare var google;
@Component({
  selector: 'showcontactform',
  templateUrl: 'show-contact.html',
  providers: [EnvDataService,ContactFormService,ADFFormService]
})
export class ShowContactForm {

  //@ViewChild('phoneNumber') phoneNumber: ElementRef;
  @ViewChild('phoneNumber') inputTxt:ElementRef;

  callMethod() {
    alert('successfully executed.')
    console.log('successfully executed.');
    //this.test++;
  }

  updateEmailPhoneForm: FormGroup;
  updateEmailPhoneFormSec: FormGroup;
  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public change_log_string: any;
  public address_format;
  public contact_uid: any;
  public showdetails:any;
  public dependent:any[];
  public employment:any[];
  public incomes:any[];
  public address:any[];
  public adfformlist:any;
  public accessGrantedFromUserstatus: number;
  public assigned_broker_name: any;
  public editPhoneOption : number = 0;
  public editEmailOption: number = 0;
  public priSec_uid: any;
  public primSecondContact: any;
  public editPhoneOptionSecond : number = 0;
  public editEmailOptionSecond: number = 0;
  public allowCustoeditPermission=0;
  public allowCustoViewOnlyPermission=0;
  public accessGrantedFromUser=0
  public adflisttable:boolean = true;
  public activelisttable:boolean = false;
  public contact_text:string = 'Show Active Campaign';
  user_data:any;
  user_data_load=false;
  adf_list_load=false;
  public adf_flag: any;
  public acApiKey: any;
  public acApiUrl: any;
  public alldeals:any;
  public ac_contact_id:any;
  public ac_deal_id:any;
  public validation_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ]
  }


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public el: ElementRef,
    private ContactFormService: ContactFormService,
    public app: App,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public popoverCtrl: PopoverController,
    public loadingProvider: LoadingProvider,
    private EnvDataService:EnvDataService,
    private ADFFormService:ADFFormService,
    public modalCtrl: ModalController,
    private menu: MenuController,
    public http : Http,
  ) {
    debugger;
    this.primSecondContact = 0;
    this.applicant_details = '';
    this.applicant_type = "Primary";
    let thiss = this;
    this.userRole = window.localStorage.getItem("userRole");
    this.contact_uid = window.localStorage.getItem("contact_uid");
    if(!this.contact_uid) {
      this.contact_uid = this.navParams.get("contact_uid");
    }
    if(!this.contact_uid) {
      //this.contact_uid = this.navParams.get("contact_uid"); //editUserId
      this.contact_uid = window.localStorage.getItem("editUserId");
    }

    console.log(this.contact_uid);

    this.updateEmailPhoneForm = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(10),Validators.maxLength(10), Validators.required])],
      edit_con_uid: ['']
    });
    this.updateEmailPhoneFormSec = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(10),Validators.maxLength(10), Validators.required])],
      edit_con_uid: ['']
    })



  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  getBrokerDetails (reference_broker){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',reference_broker ).where('deleted','<',1 )).valueChanges ();
  }

  ngOnInit() {
    console.log('this.contact_uid',this.contact_uid)
    this.contctDetails();
    this.adfFromList();
    let thiss = this;
    //this.getCloneAdfList();

    var docRef0 = firebase.firestore().collection("ac_credentials").doc('acCredentials_API');
    docRef0.get().then(function(doc) {
      if (doc.exists) {
        let user_data = doc.data();
        console.log(user_data);
        thiss.acApiKey = user_data.acApiKey;
        thiss.acApiUrl = user_data.acApiUrl;



      } else {
        console.log("No such document!");
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });
  }

  contctDetails(){
    debugger;
    this.ContactFormService.getApplicantDetails(this.contact_uid).then((data:any) => {
      console.log('contctDetails',data)
      debugger;
      if(data.contact_details) {
          if(data.contact_details.address) {
            this.address_format = data.contact_details.address[0].address_format;
          }
          else {
            this.address = [];
          }

      }

      this.showdetails = data;
      this.user_data = data.user_data;
      this.allowCustoeditPermission= (data.user_data.allowCustoeditPermission == undefined) ? 0 : data.user_data.allowCustoeditPermission;
      this.allowCustoViewOnlyPermission= (data.user_data.allowCustoViewOnlyPermission == undefined) ? 0 : data.user_data.allowCustoViewOnlyPermission;
      this.accessGrantedFromUser= (data.user_data.accessGrantedFromUser == undefined) ? 0 : data.user_data.accessGrantedFromUser;

      if(data.contact_details) {
        this.dependent = data.contact_details.dependent;
        this.employment = data.contact_details.employment_details==undefined?[]:data.contact_details.employment_details;
        if(data.contact_details.employment_details) {
          this.incomes = data.contact_details.employment_details.incomes==undefined?[]:data.contact_details.employment_details.incomes;
        }

        this.address = data.contact_details.address;
      }
      else {
        this.dependent =[];
        this.employment = [];
        this.incomes = [];
        this.address = [];


      }

      this.user_data_load =true;
      console.log('show contact from list', this.showdetails);
      let reference_broker = this.showdetails.user_data.reference_broker;
      if(reference_broker == "" || reference_broker == null || reference_broker == undefined){}else{
      this.getBrokerDetails(reference_broker).subscribe((brokerDetails)=>{
        if(brokerDetails.length > 0){
          this.assigned_broker_name = brokerDetails[0].firstname +' '+ brokerDetails[0].lastname;
        }else{
          this.assigned_broker_name = 'Broker not assigned';
        }
      });

    }

    //this.getACByEmail();
    });

  }

 viewMoreAddress(user_data) {
    //debugger;
    let previousadress = [];

    this.address.forEach(addresselement => {
        if(addresselement.type == 'previous') {
          previousadress.push(addresselement);
        }
     });
     user_data.previousAddress = previousadress;
    let viewMoreAddress = this.modalCtrl.create(ViewMoreAddressPage, {
      "user_data": user_data
    });

    viewMoreAddress.present();
  }

  adfFromList(){
    let thiss = this;
    this.ContactFormService.getAllApplicantDetailsbyId(this.contact_uid).then((data:any) => {

      console.log('dataadf form',data);
      data.forEach(adfelement => {
          if(adfelement.hasOwnProperty('accessGrantedFromUser')){
             // console.log('yes exits');
          }
          else {
            adfelement.accessGrantedFromUser = 0;
          }
       });
       thiss.adfformlist=data;

      //console.log(thiss.adfformlist);
      //debugger;
      thiss.adf_list_load=true;
    });
  }
  // getCloneAdfList() {
  //   this.ContactFormService.getCloneAdfList(this.contact_uid).then((data:any)=>{
  //     console.log('clone adf form today',data);
  //   })
  // }

  viewContact(event, contact_uid, SDF_form_document_id){
    console.log('contact_uid',contact_uid);
    console.log('SDF_form_document_id',SDF_form_document_id);
    this.navCtrl.push(ViewAdfPage,{
      contact_uid:contact_uid,
      SDF_form_document_id:SDF_form_document_id
    });
  }

  newAdf(event,SDF_form_document_id,adf_title) {

    let alert = this.alertCtrl.create({
      title: 'Do you want to create a copy of '+adf_title+'?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Yes clicked');
            this.ContactFormService.cloneApplicantDetailsbyId(SDF_form_document_id).then((data:any) => {

              this.adfFromList();

              this.navCtrl.push(AdfPage,{
                 user_id:data.user_id,
                 form_id:data.adf_form_id,
                 edit_flag:'edit'
               });
           })
          }
        }
      ]
    });
    alert.present();


  }

  editAdfForm(user_id, SDF_form_document_id){
    debugger;
    console.log('data 1',user_id);
    console.log('data 2',SDF_form_document_id);
    this.navCtrl.push(AdfPage,{
      user_id:user_id,
      form_id:SDF_form_document_id,
      edit_flag:'edit'
    });
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      console.log(e)
    }
  }

  closeButton(event) {
    this.editEmailOption = 0;
    this.editPhoneOption = 0;
    this.editEmailOptionSecond = 0;
    this.editPhoneOptionSecond = 0;
  }


  changeEmailPhone(event, form, userType, type) {
    let selectedForm = form;
    debugger;

    if (type == 'email') {
      let getemail = selectedForm.get('email');
      let getmobile_phone = selectedForm.get('mobile_phone');
      getemail.setValidators([Validators.required, Validators.email, Validators.minLength(10), Validators.required]);
      getmobile_phone.setValidators(null);
      getemail.updateValueAndValidity();
      getmobile_phone.updateValueAndValidity();
      if (userType == 'primary') {
        this.editEmailOption = 1;
        this.editPhoneOption = 0;
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 0;
      } else if (userType == 'secondary') {
        this.editEmailOptionSecond = 1;
        this.editPhoneOptionSecond = 0;
        this.editEmailOption = 0;
        this.editPhoneOption = 0;
      }
    } else if (type == 'phone') {
      debugger;
      //let mobile_phone = this.user_data.mobile_phone;

      let getemail = selectedForm.get('email');
      let getmobile_phone = selectedForm.get('mobile_phone');
      let phone_input = this.user_data.mobile_phone.replace(/\s/g, "");
      this.user_data.mobile_phone=phone_input;
      console.log(phone_input);

      getmobile_phone.setValidators([Validators.minLength(10), Validators.maxLength(10), Validators.required]);
      getmobile_phone.setValue(phone_input);
      getemail.setValidators(null);
      getemail.updateValueAndValidity();
      getmobile_phone.updateValueAndValidity();
      if (userType == 'primary') {
        this.editEmailOption = 0;
        this.editPhoneOption = 1;
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 0;

        //console.log(this.inputTxt.nativeElement.value);
      } else if (userType == 'secondary') {
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 1;
        this.editEmailOption = 0;
        this.editPhoneOption = 0;
      }
    }
  }
  phoneInput(event) {
    debugger;

    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  setFormatNumber(mobile_phone) {
    debugger;
    //let selectedForm = form;
    //console.log()
    let getmobile_phone = mobile_phone;
     console.log(getmobile_phone);
    getmobile_phone = getmobile_phone.split(" ").join("");
    let firstFour = getmobile_phone.slice(0, 4);
    let number = getmobile_phone.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);

    return number;
    //    this.formApplicant.controls[index]['controls'].secondary_mobile_phone.setValue(number.trim());
    //selectedForm.value.mobile_phone = number;
  }

  updateEmailPhone(contact_id, form, userType) {
    debugger;
    let userForm = form;
    if (!userForm.valid) {

      userForm.get('email').markAsDirty();
      userForm.get('email').markAsTouched();

      userForm.get('mobile_phone').markAsDirty();
      userForm.get('mobile_phone').markAsTouched();

    } else {

      this.loadingProvider.startLoading();
      // console.log(this.phoneNumber.nativeElement.value);
      let email = userForm.value.email;
      let mobile_phone='';
      if(userForm.value.mobile_phone !== '') {
         mobile_phone = this.setFormatNumber(userForm.value.mobile_phone);
        userForm.value.mobile_phone = mobile_phone;
      }
      // else {
      //      mobile_phone = userForm.value.mobile_phone;
      // }


      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        "email": email,
        "phoneNumber": "+6" + mobile_phone,
        "mobile_phone": mobile_phone,
        "contact_id": contact_id
      }
      var url = this.EnvDataService.EnvData.sendbox_api + "/updateViewPageContactDetails";
      this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if (data['_body'] == 'The email address is already in use by another account.') {
            this.presentToast(data['_body']);
          } else if (data['_body'] == 'The user with the provided phone number already exists.') {
            this.presentToast(data['_body']);
          } else if (data['_body'] == 'TOO_LONG') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'TOO_SHORT') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'Invalid format.') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.') {
            this.presentToast('Invalid Phone Number.');
          } else {
            this.editEmailOption = 0;
            this.editPhoneOption = 0;
            this.editEmailOptionSecond = 0;
            this.editPhoneOptionSecond = 0;
            if (email != "") {
              if (userType == 'primary') {
                this.user_data.email = email;
              } else if (userType == 'secondary') {
                this.primSecondContact.email = email;
              }
            }
            if (mobile_phone != "") {
              if (userType == 'primary') {
                this.user_data.mobile_phone = mobile_phone;
              } else if (userType == 'secondary') {
                this.primSecondContact.mobile_phone = mobile_phone;
              }
            }
          }
          this.loadingProvider.stopLoading();
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
    }
  }


  viewSingleAssets(i, type){
    debugger
    if(type == 'income'){
      if(this.incomes[i].show == 1){
        this.incomes[i].show = 0;
      }else{
        this.incomes[i].show = 1;
      }
    }
  }

  viewContactPDF(event, contact_uid, t_document_id, SDF_form_document_id){
    this.navCtrl.push(ShowContactPdfPage,{
      contact_uid:this.contact_uid,
      });
  }

  edit(i){
    console.log(this.adfformlist[i]);
  }


  delete(i) {
    console.log(this.adfformlist[i]);
    let uid= this.contact_uid;
    let afdID=this.adfformlist[i].adf_form_id;

    let alert = this.alertCtrl.create({
      title: 'Confirm delete Application',
      message: 'Are you sure you want to delete this Application?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Yes clicked');
            this.ContactFormService.deleteSpecificApplication(uid,afdID).then((data: any) => {
              console.log('data',data)
              if (data.message == "Document successfully deleted!") {
                this.adfFromList();
              } else {
                this.presentToast(data.message);
              }
            });
          }
        }
      ]
    });
    alert.present();
  }



  editContact(){
    // this.navCtrl.pop();
    //var nav = this.app.getRootNav();
    window.localStorage.setItem("editUserId", this.contact_uid);
    //nav.setRoot(EditContactList);

    this.navCtrl.push(EditContactList,{
      'editUserId':this.contact_uid
    });

  }

  permissionToUser(event, contact_uid, allowCustoeditPermission, allowCustoViewOnlyPermission, SDF_form_document_id){
    debugger;

    if(this.adf_flag) {
      console.log('abc');
      console.log(this.adf_flag);
      allowCustoeditPermission = this.adf_flag.allowCustoeditPermission;
      allowCustoViewOnlyPermission = this.adf_flag.allowCustoViewOnlyPermission;
    }

    let reference_broker_uid = this.user_data.reference_broker;
    let customer_email = this.user_data.email;
    let customer_password = this.user_data.password;
    let broker_email:any;
    let firstname = this.user_data.firstname;
    this.ADFFormService.getUsersDataByUser(reference_broker_uid).then((data:any)=>{
      broker_email = data.email;

      let editMenu = this.popoverCtrl.create(AllowCustomerContactPermissionPage,
        {contact_uid: contact_uid,
        allowCustoeditPermission: allowCustoeditPermission,
        allowCustoViewOnlyPermission: allowCustoViewOnlyPermission,
        customer_email:customer_email,
        customer_password:customer_password,
        broker_email:broker_email,
        firstname:firstname,

      }, {showBackdrop: true, cssClass: 'popOverClass'});
      editMenu.present({
         ev: event
      });
      editMenu.onDidDismiss((data) => {
        //alert('working');
        this.adf_flag = data;
        console.log(this.adf_flag);
      })

    })


  }

  unapproved(firstname, lastname){
    let uid = window.localStorage.getItem("uid");
    let brokerName = window.localStorage.getItem("brokerFirstname")+' '+window.localStorage.getItem("brokerLastname");
    this.userRole = window.localStorage.getItem("userRole");
    let alert = this.alertCtrl.create({
      title: 'Are you sure',
      message: 'Do you want to reset the customer approval of this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(this.contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let priSec_uid = '';
                  if(this.priSec_uid != null){
                    priSec_uid = this.priSec_uid;
                  }
                  let pri_contact_uid = this.contact_uid;
                  if(this.user_data.contact_type != 'Primary Contact'){
                    pri_contact_uid = this.priSec_uid;
                  }
                  let ckuserRole = 'Broker';
                  if(this.userRole == 'super_admin'){
                    ckuserRole = 'Super Admin';
                  }else if(this.userRole == 'loan_admin'){
                    ckuserRole = 'Loan Admin';
                  }
                  let postData = {
                    'contact_uid' : this.contact_uid,
                    'priSec_uid' : priSec_uid,
                    "created_date" : new Date().getTime(),
                    "contact_type" : this.user_data.contact_type,
                    "pri_contact_uid" : pri_contact_uid,
                    "brokerName" : brokerName,
                    "userRole" : ckuserRole,
                    "user_history_created_by": uid,
                    "name": firstname +' '+ lastname,
                    "SDF_form_document_id": this.SDF_form_document_id
                  }
                  let url = this.EnvDataService.EnvData.sendbox_api+"/unapprovedSubmittion";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'error'){
                      this.presentToast('Something went wrong please try again later.');
                    }else{
                      this.presentToast('Reset customer approval successfully.');
                      this.user_data.accessGrantedFromUser = 0;
                      postData['ip_address'] = data['_body'];
                      postData['status'] = 5;
                      this.user_history_data(postData)
                    }
                    this.loadingProvider.stopLoading();
                  }, error => {
                    this.presentToast(error.message);
                  });
                }
              }
          }
      ]
    });
    alert.present();
  }


  addNewAdf(event) {
    // console.log(this.user_data);
    // debugger;
    this.navCtrl.push(AdfPage,{
      contact_email:this.user_data.email,
      contact_page:true
    });
  }

  // popupAction(event: any, contact_uid: any, SDF_form_document_id: any, contact_type: any){
  //   let editMenu = this.popoverCtrl.create(EditPopoverPage, {contact_uid: contact_uid, view_contact: 'yes', SDF_form_document_id: SDF_form_document_id, contact_type: contact_type}, {showBackdrop: true, cssClass: 'popOverClass'});
  //   editMenu.present({
  //      ev: event // <-- the fix
  //   });

  //   editMenu.onDidDismiss(data =>{
  //     if(data == "" || data == null || data == undefined){}else{
  //       if(data.type == 'viewcontact'){
  //         let contact_uid = data.contact_uid;
  //         this.navCtrl.push(ViewContactPage,{
  //           contact_uid:contact_uid,
  //           SDF_form_document_id: SDF_form_document_id
  //         });
  //       }else if(data.type == 'editcontact'){
  //         let contact_uid = data.contact_uid;
  //         this.navCtrl.push(StepformPage,{
  //           edit_contact_uid:contact_uid,
  //           SDF_form_document_id: SDF_form_document_id
  //         });
  //       }else if(data.type == 'addsecondary'){
  //         window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
  //         window.localStorage.setItem("creating_second", 'yes');
  //         this.navCtrl.push(StepformPage);
  //       }else if(data.type == 'realestate'){
  //         window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
  //         window.localStorage.setItem("contact_second_uid", data.second_contact_id);
  //         window.localStorage.setItem("SDF_form_document_id", data.SDF_form_document_id);
  //         this.navCtrl.push(RealEstatePage,{
  //           edit_contact_uid:data.contact_id_add_real_estate,
  //           second_contact_id : data.second_contact_id,
  //           SDF_form_document_id : data.SDF_form_document_id
  //         });
  //         window.localStorage.setItem("generate_new_tentative", '1');
  //       }else if(data.type == 'tentativerealestate'){
  //         window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
  //         window.localStorage.setItem("contact_second_uid", data.second_contact_id);
  //         window.localStorage.setItem("SDF_form_document_id", data.SDF_form_document_id);
  //         this.navCtrl.push(TentativeRealEstateAssetPage,{
  //           edit_contact_uid:data.contact_id_add_real_estate,
  //           second_contact_id : data.second_contact_id,
  //           SDF_form_document_id : data.SDF_form_document_id
  //         });
  //         window.localStorage.setItem("generate_new_tentative", '1');
  //       }else if(data.type == 'changelog'){
  //         let contact_uid = data.contact_uid;
  //         this.navCtrl.push(ChangeLogProfilePage,{
  //           contact_uid:contact_uid
  //         });
  //       }else if(data.type == 'syncMercury'){
  //         this.syncInMercury('', data.userData, '', data.userData.accessGrantedFromUser);
  //       }
  //     }
  //   });
  // }


  user_history_data(postData){
    const user_history = this.db.collection('/user_history');
    user_history.doc(postData.contact_uid + '_'+ postData.created_date).set({
        created_date : postData.created_date,
        contact_uid : postData.contact_uid,
        document_id: postData.contact_uid+'_'+postData.created_date,
        ip_address: postData.ip_address,
        uid: postData.user_history_created_by,
        contact_type: postData.contact_type,
        name: postData.name,
        status: postData.status,
        deleted : 0
    }).then(function() {

    }).catch(function(error) {

    });
  }

  showCampaign() {
    this.adflisttable = !this.adflisttable;
    this.activelisttable=!this.activelisttable;
    if(!this.adflisttable) {
      this.contact_text ="Show Adf List";
    }
    else {
      this.contact_text ="Show Active Campaign";
    }

  }
  getACByEmail() {
    let thiss = this;
    console.log(this.user_data);
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    headers.append('Access-Control-Allow-Origin', '*' );
    headers.append('Api-Token', this.acApiKey );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      "acApiKey" : this.acApiKey,
      "acApiUrl" : this.acApiUrl,
      "email":this.user_data.email
    }
    console.log(postData);
    var url = this.EnvDataService.EnvData.sendbox_api+"/getACByEmail";
    this.http.post(url, postData,requestOptions)
    .subscribe(data => {
      console.log('its working');
      console.log(data);
      let resdata =  JSON.parse(data['_body']);
       let contact_id = resdata.contacts[0].id;
       this.ac_contact_id=contact_id;
       console.log(resdata);
       thiss.getAllDealsById(contact_id);

    }, error => {

    });
  }

  getAllDealsById(contact_id) {
    console.log(contact_id);

    let thiss = this;
    console.log(this.user_data);
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    headers.append('Access-Control-Allow-Origin', '*' );
    headers.append('Api-Token', this.acApiKey );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      "acApiKey" : this.acApiKey,
      "acApiUrl" : this.acApiUrl,
      "email":this.user_data.email,
      "contact_id":contact_id
    }
    console.log(postData);
    var url = this.EnvDataService.EnvData.sendbox_api+"/getAllDealsById";
    this.http.post(url, postData,requestOptions)
    .subscribe(data => {
      console.log('now working');
      console.log(data);
      let resdata =  JSON.parse(data['_body']);
      console.log(resdata.deals);
       //thiss.getAllDealsDetailsById()
        resdata.deals.forEach(dealelement => {
            let stage_id = dealelement.stage;
            thiss.ContactFormService.getstateMessage(stage_id).then((data)=>{
              console.log('its sdsdsd');
              dealelement.stageinfo = data;
            })
            console.log(stage_id);
        });
        thiss.alldeals = resdata.deals;

    }, error => {

    });
  }

  viewDeal(event,dealid,ac_status) {
    this.navCtrl.push(ViewDealPage,{
      ac_contact_id:this.ac_contact_id,
      ac_deal_id:dealid,
      acApiKey : this.acApiKey,
      acApiUrl : this.acApiUrl,
      ac_status:ac_status
    });
  }

  openmenu() {
    this.menu.open('first');
  }

  changeBroker(event,i) {
    console.log(event);

    let editMenu = this.popoverCtrl.create(BrokerpagepopComponent,
      {
        contact_uid: this.contact_uid,

    }, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event
    });
    editMenu.onDidDismiss((data) => {
      //alert('working');
      //this.adf_flag = data;
      console.log(data);
      this.user_data.reference_broker = data.id;
       if(data) {
        this.assigned_broker_name = data.name;
       }

    })
  }

}




// WEBPACK FOOTER //
// ./src/pages/show-contact/show-contact.ts